module.exports = __webpack_public_path__ + "img/Loyalty-ability-03.5cb12319.png";